<div
  class="sp-width__full sp-height__full sp-page__with-navbar"
  [ngClass]="getNavbarClass()">
  <app-navbar
    class="sp-hidden__before-lg"
    [current_nav_item]="current_nav_item"
    [navbar_status]="navbar_status"
    (status_change)="onNavbarStatusChange($event)"></app-navbar>

  <div class="sp-position__relative">
    <app-toolbar
      [current_nav_item]="current_nav_item"
      [width_class]="getToolbarWidthClass()"></app-toolbar>

    <div class="sp-page__with-absolute-toolbar sp-grid__gap sp-padding__x2 sp-seller-details__grid">
      <app-seller-details-header
        [seller_id]="seller_id"
        (tab_change)="onTabChange($event)"
        (refresh)="onRefresh()"></app-seller-details-header>

      <app-seller-details-general
        *ngIf="current_tab === tabs.get('article')"
        [seller_id]="seller_id"></app-seller-details-general>

      <app-seller-details-event-data
        *ngIf="current_tab === tabs.get('timeline')"
        [seller_id]="seller_id"></app-seller-details-event-data>
    </div>
  </div>
</div>
